// Mémorise les paramètres publicitaires (UTM Meta) de la visite d'arrivée,
// pour les retrouver si le prospect revient plus tard sans eux dans l'URL.
const STORAGE_KEY = 'pulsia_utm';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const TRACKING_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

function readSaved() {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (saved && Date.now() - saved.saved_at < MAX_AGE_MS) return saved.params;
  } catch {
    // stockage indisponible ou valeur illisible
  }
  return {};
}

// Une nouvelle visite avec des UTM remplace les précédents (dernière pub cliquée).
export function captureTrackingParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const fromUrl = {};
  TRACKING_PARAMS.forEach((key) => {
    if (urlParams.get(key)) fromUrl[key] = urlParams.get(key);
  });
  if (Object.keys(fromUrl).length === 0) return;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ params: fromUrl, saved_at: Date.now() }));
  } catch {
    // stockage indisponible : les UTM restent lus depuis l'URL au moment de l'envoi
  }
}

export function getTrackingParams() {
  captureTrackingParams();
  const saved = readSaved();
  const tracking = {};
  TRACKING_PARAMS.forEach((key) => {
    tracking[key] = saved[key] || '';
  });
  // Si le stockage est bloqué, l'URL courante reste la source
  const urlParams = new URLSearchParams(window.location.search);
  TRACKING_PARAMS.forEach((key) => {
    if (urlParams.get(key)) tracking[key] = urlParams.get(key);
  });
  return tracking;
}
